import { ContainerClient } from "@azure/storage-blob";

export async function downloadConfigFile<TConfig>(containerClient: ContainerClient, fileName: string): Promise<TConfig> { 
    // Get blob client  
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);

    // Download config file         
    const downloadResponse = await blockBlobClient.download();
    const blob = await downloadResponse.blobBody;
    const text = await blob?.text();
    const json = JSON.parse(text as string);
    return json;
}